import React from 'react';

export const ShareTemplateSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12837_93430)">
      <path
        d="M14.6443 8.02656V14.0067C14.6443 14.3734 14.3466 14.6711 13.9799 14.6711L2.01974 14.6711C1.65296 14.6711 1.3553 14.3734 1.3553 14.0067L1.3553 8.02656C1.3553 7.65913 1.0583 7.36213 0.690867 7.36213C0.32343 7.36213 0.0263672 7.65913 0.0263672 8.02656L0.0263672 14.0067C0.0263672 15.1057 0.920742 16 2.01974 16H13.9799C15.0789 16 15.9732 15.1057 15.9732 14.0067V8.02656C15.9732 7.65913 15.6762 7.36213 15.3088 7.36213C14.9413 7.36213 14.6443 7.65913 14.6443 8.02656Z"
        fill="currentColor"
      />
      <path
        d="M7.52664 0.197951L3.53992 4.23783C3.28211 4.4983 3.28546 4.91955 3.54658 5.17736C3.80771 5.43517 4.2283 5.43251 4.48611 5.1707L7.33527 2.28367V10.0199C7.33527 10.3873 7.63227 10.6843 7.99971 10.6843C8.36714 10.6843 8.66417 10.3873 8.66417 10.0199L8.66417 2.28367L11.5133 5.1707C11.7711 5.43248 12.1917 5.43448 12.4529 5.17736C12.5844 5.04714 12.6509 4.8757 12.6509 4.70426C12.6509 4.53548 12.5871 4.36673 12.4595 4.23783L8.47277 0.197951C8.34786 0.0717013 8.17774 -4.86374e-05 7.99967 -4.86374e-05C7.82167 -4.86374e-05 7.65224 0.0710451 7.52664 0.197951Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12837_93430">
        <rect
          width="16"
          height="16"
          fill="currentColor"
          transform="matrix(0 -1 1 0 0 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ShareTemplateSvg;
